import { UserTransaction } from "../../types/user-transaction.entity";
import { displayDate } from "src/utils/dateHandler.util";
import { Amount } from "src/components/Amount";
import { formatScreamingSnakeCase } from "src/utils/util";
import { transactionStatusStyles, transactionTypeStyles } from "../../utils/transaction-style";
import { TransactionLabelPill } from "./label";
import { MenuActions } from "src/components/menu-actions";
import { getUserTransactionActions } from "../../utils/transaction-actions";
import { useModal } from "src/components/modal/use-modal";
import { RefundModal } from "../refund-session-transaction/refund-modal";
import { Badge } from "./badge";
type Props = {
  data: UserTransaction[];
};
export const UsersTransactionsTable = ({ data }: Props) => {
  const refundModal = useModal<UserTransaction>();

  const refundTransaction = (transaction: UserTransaction) => {
    refundModal.open(transaction);
  };

  return (
    <div>
      <div className="overflow-x-auto mb-6">
        <table className="min-w-full border border-gray-200 divide-y divide-gray-200">
          <thead className="bg-gray-800 text-white text-center">
            <tr>
              <th className="px-4 py-3">Id</th>
              <th className="px-4 py-3">Amount</th>
              <th className="px-4 py-3">Type</th>
              <th className="px-4 py-3">Status</th>
              <th className="px-4 py-3">Date</th>
              <th className="px-4 py-3">Reason</th>
              <th className="px-4 py-3">View</th>
            </tr>
          </thead>

          <tbody>
            {data.map((tx) => (
              <tr key={tx.id} className="text-center odd:bg-white even:bg-gray-50 hover:bg-gray-100">
                <td className="px-4 py-3 border-t border-gray-200 max-w-xs whitespace-nowrap overflow-hidden text-ellipsis">
                  {tx.id}
                </td>
                <td className="px-4 py-3 border-t border-gray-200">
                  <Amount amount={tx.amount} currency={tx.currency} />
                </td>
                <td className="px-4 py-3 border-t border-gray-200">
                  <Badge label={formatScreamingSnakeCase(tx.type)} classes={transactionTypeStyles[tx.type]} />
                </td>
                <td className="px-4 py-3 border-t border-gray-200">
                  <Badge label={formatScreamingSnakeCase(tx.status)} classes={transactionStatusStyles[tx.status]} />
                </td>
                <td className="px-4 py-3 border-t border-gray-200">{displayDate(tx.createdAt)}</td>
                <td className="px-4 py-3 border-t border-gray-200">
                  <TransactionLabelPill label={tx.label} />
                </td>
                <td className="px-4 py-3 border-t border-gray-200">
                  <MenuActions actions={getUserTransactionActions({ transaction: tx, refundTransaction })} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {data.length === 0 && <p className="px-4 py-3 text-center text-gray-500">No Transactions Found</p>}
      {refundModal.isOpen && (
        <RefundModal transaction={refundModal.data!} close={() => refundModal.close()} />
      )}
    </div>
  );
};
